<template>
    <section class="app-main">
        <transition name="fade-transform" mode="out-in">
            <keep-alive >
                <router-view :key="key" />
            </keep-alive>
        </transition>
    </section>
</template>

<script>
    export default {
        name: "appMain",
        computed: {
            key() {
                return this.$route.path
            }
        }
    }
</script>

<style scoped>
    .app-main {
        min-height: calc(100vh - 213px);
        /*height: calc(100vh - 153px);*/
        /* 50= navbar  50  */
        /*min-height: calc(100vh - 50px);*/
        /*width: 100%;*/
        /*position: relative;*/
        /*overflow: hidden;*/
    }
</style>